<template>
  <h2 class="titleStepForm">Account/Fees</h2>
  <div class="">
    <table class="table table-bordered table-custom-card">
      <thead>
        <tr>
          <th>A/C Number</th>
          <th>A/C Type</th>
          <th>Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <input
              type="number"
              v-model="form.personal.account_one"
              class="form-control"
              :class="{
                'is-invalid':
                  v$.form.personal.account_one.$error,
              }"
            />
            <div
              v-for="(personal, index) in v$.form.personal
                .account_one.$errors"
              :key="index"
              class="invalid-feedback"
            >
              <span v-if="personal.$message"
                >{{ personal.$message }}
              </span>
            </div>
          </td>
          <td>Shares</td>
          <td>
            <div class="input-group">
              <div class="input-group-text">$</div>
              <input
                type="number"
                v-model="form.personal.shares_amount"
                class="form-control"
                :class="{
                  'is-invalid':
                    v$.form.personal.shares_amount.$error,
                }"
              />
              <div
                v-for="(personal, index) in v$.form.personal
                  .shares_amount.$errors"
                :key="index"
                class="invalid-feedback"
              >
                <span v-if="personal.$message"
                  >{{ personal.$message }}
                </span>
              </div>
            </div>
          </td>
        </tr>

        <tr>
          <td>
            <input
              type="number"
              v-model="form.personal.account_two"
              class="form-control"
              :class="{
                'is-invalid':
                  v$.form.personal.account_two.$error,
              }"
            />
            <div
              v-for="(personal, index) in v$.form.personal
                .account_two.$errors"
              :key="index"
              class="invalid-feedback"
            >
              <span v-if="personal.$message"
                >{{ personal.$message }}
              </span>
            </div>
          </td>
          <td>Special Shares</td>
          <td>
            <div class="input-group">
              <div class="input-group-text">$</div>
              <input
                type="number"
                v-model="form.personal.special_shares_amount"
                class="form-control"
                :class="{
                  'is-invalid':
                    v$.form.personal.special_shares_amount
                      .$error,
                }"
              />
              <div
                v-for="(personal, index) in v$.form.personal
                  .special_shares_amount.$errors"
                :key="index"
                class="invalid-feedback"
              >
                <span v-if="personal.$message"
                  >{{ personal.$message }}
                </span>
              </div>
            </div>
          </td>
        </tr>

        <tr>
          <td>
            <input
              type="number"
              v-model="form.personal.account_three"
              class="form-control"
              :class="{
                'is-invalid':
                  v$.form.personal.account_three.$error,
              }"
            />
            <div
              v-for="(personal, index) in v$.form.personal
                .account_three.$errors"
              :key="index"
              class="invalid-feedback"
            >
              <span v-if="personal.$message"
                >{{ personal.$message }}
              </span>
            </div>
          </td>
          <td>Deposit A/C</td>
          <td>
            <div class="input-group">
              <div class="input-group-text">$</div>
              <input
                type="number"
                v-model="form.personal.deposit_ac_amount"
                class="form-control"
                :class="{
                  'is-invalid':
                    v$.form.personal.deposit_ac_amount.$error,
                }"
              />
              <div
                v-for="(personal, index) in v$.form.personal
                  .deposit_ac_amount.$errors"
                :key="index"
                class="invalid-feedback"
              >
                <span v-if="personal.$message"
                  >{{ personal.$message }}
                </span>
              </div>
            </div>
          </td>
        </tr>

        <tr>
          <td>
          </td>
          <td>
            <strong class="font-weight-500">Reg. Fee</strong>
          </td>
          <td>
            <div class="input-group">
              <div class="input-group-text">$</div>
              <input
                type="number"
                v-model="form.personal.reg_fee_amount"
                class="form-control"
                :class="{
                  'is-invalid':
                    v$.form.personal.reg_fee_amount.$error,
                }"
              />
              <div
                v-for="(personal, index) in v$.form.personal
                  .reg_fee_amount.$errors"
                :key="index"
                class="invalid-feedback"
              >
                <span v-if="personal.$message"
                  >{{ personal.$message }}
                </span>
              </div>
            </div>
          </td>
        </tr>

        <tr>
          <td>
          </td>
          <td>
            <strong class="font-weight-500">Total</strong>
          </td>
          <td>
            <div class="input-group">
              <div class="input-group-text">$</div>
              <input
                type="number"
                v-model="form.personal.total_amount"
                class="form-control"
                :class="{
                  'is-invalid':
                    v$.form.personal.total_amount.$error,
                }"
              />
              <div
                v-for="(personal, index) in v$.form.personal
                  .total_amount.$errors"
                :key="index"
                class="invalid-feedback"
              >
                <span v-if="personal.$message"
                  >{{ personal.$message }}
                </span>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { bridge } from "../formBridge";

export default {
  name: "ReviewAccountFees",
  props: {
    variant: { type: String, default: "review" },
  },
  computed: {
    isPdf() {
      return this.variant === "pdf";
    },
  },
  mixins: [
    bridge({
    state: ["form"],
    validate: true,
    }),
  ],
};
</script>
